module.exports = __webpack_public_path__ + "img/centCorte2.b21912f3.jpg";